
const env = {
    env: process.env.REACT_APP_ENV,
    app: {
        port: 3000
    },
    urls: {
      graphql: process.env.REACT_APP_GRAPHQL_URL,
      employees: process.env.REACT_APP_EMPLOYEES_URL,
      assets: process.env.REACT_APP_ASSETS_URL
    }
};

module.exports = env;
